// src/features/projects/orgsApi.ts
import api from 'src/shared/api/axios';

export type ProjectOrg = {
    id: string;
    projectId: string;
    name: string;
    createdAt?: string;
    updatedAt?: string;
};

type ListProjectOrgsResponse = {
    ok: boolean;
    result: ProjectOrg[];
};

type CreateProjectOrgResponse = {
    ok: boolean;
    result: ProjectOrg;
};

export async function listProjectOrgs(projectId: string): Promise<ProjectOrg[]> {
    const { data } = await api.get<ListProjectOrgsResponse>(`/projects/${projectId}/orgs`);
    const arr = data?.result;
    return Array.isArray(arr) ? arr : [];
}

export async function createProjectOrg(projectId: string, name: string): Promise<ProjectOrg> {
    const { data } = await api.post<CreateProjectOrgResponse>(`/projects/${projectId}/orgs`, { name });
    return data.result;
}